import  { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Logomintic from '../assets/Mintic.svg';
import Logooracle from '../assets/Oracle-Logo 1 1.svg';
import Logounad from '../assets/Unad.svg';
import Logoclaro from '../assets/claro 1.svg';
import Logobogota from '../assets/bogota.svg';

const Logoudec = process.env.PUBLIC_URL + '/udec1.svg';

const Partners = () => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Llamada inicial para establecer el tamaño
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const carouselSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const logos = [
    { src: Logounad, alt: 'Unad' },
    { src: Logoclaro, alt: 'Claro' },
    { src: Logooracle, alt: 'Oracle' },
    { src: Logobogota, alt: 'Bogotá' },
    { src: Logoudec, alt: 'Udec' },
    { src: Logomintic, alt: 'Mintic' },
  ];

  const renderGrid = () => (
    <div className="grid grid-cols-3 gap-4 md:grid-cols-3 lg:grid-cols-6 place-items-center w-full">
      {logos.map((logo, index) => (
        <div key={index} className="flex justify-center items-center">
          {/* Ajusta aquí el tamaño: w-48 */}
          <img src={logo.src} alt={logo.alt} className="logo-style w-48 h-auto" />
        </div>
      ))}
    </div>
  );

  const renderCarousel = () => (
    <Slider {...carouselSettings}>
      {logos.map((logo, index) => (
        <div key={index} className="flex justify-center items-center">
          {/* Ajusta aquí el tamaño para el carrusel: w-48 */}
          <img src={logo.src} alt={logo.alt} className=" w-32 h-auto mx-auto" />
        </div>
      ))}
    </Slider>
  );

  return (
    <section className="bg-lightGray text-center" id="partners">
      <div className="bg-white divider-conteiner text-center">
        <h1 className="font-sans text-primary font-bold resp-h3">{t('partners.title')}</h1>
        <p className="font-content hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('partners.subtitle')}
        </p>
      </div>
      <div className='mb:m-4 m-8 flex justify-center'>
        <div className="w-[90%] mb-4">
          {isMobile ? renderCarousel() : renderGrid()}
        </div>
      </div>
    </section>
  );
};

export default Partners;
